import { bool, string } from 'prop-types'

const Source = props => (
  <source
    media={props.media}
    type={props.type}
    data-srcset={props.lazyLoad ? props.srcSet : null}
    srcSet={props.lazyLoad ? null : props.srcSet}
  />
)

Source.propTypes = {
  lazyLoad: bool,
  media: string,
  type: string,
  srcSet: string,
}

Source.defaultProps = {
  lazyLoad: false,
  media: null,
  type: null,
  srcSet: null,
}

export default Source
